import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'users-conected',
  templateUrl: './users-conected.component.html',
  styleUrls: ['./users-conected.component.scss'],
})
export class UsersConectedComponent implements OnInit {
  constructor(
    private readonly userService: UserService,
    private readonly dialog: MatDialog
  ) {}

  users: any;
  ngOnInit() {
    this.getUsers();
  }
  async getUsers() {
    await this.userService.getUsersConected().subscribe((res: any) => {
      this.users = res;
      this.setData(res);
    });
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource: MatTableDataSource<IUser>;

  filter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
  }

  get canCreate() {
    return this.userService.permissions?.createUsers;
  }
  get canEdit() {
    return this.userService.permissions?.editUsers;
  }

  get canDelete() {
    return this.userService.permissions?.deleteUsers;
  }

  usersList: IUser[] = [];
  displayedColumns: string[] = [
    'spacing',
    // 'photo',
    'fullname',
    'username',
    'role',
    'count',
    // 'active',
  ];

  setData(users: IUser[]) {
    this.usersList = users;
    this.dataSource = new MatTableDataSource(users);
    this.dataSource.paginator = this.paginator;
  }

  getPhoto(user: IUser) {
    return user.photo || 'assets/images/user.png';
  }
}
